import {
    HelpTopic,
    HelpTopicMetadataContext,
    GetHelpTopicMetadataRequest,
    GetHelpTopicMetadataResponse,
} from "src/api/Tmd.dtos";
import type { SWRConfiguration } from "swr";
import useBaseFormMetadata from "../useBaseFormMetadata";

const useHelpTopicFormMetadata = (
    model?: HelpTopic | null,
    context?: HelpTopicMetadataContext | null,
    configuration?: SWRConfiguration<
        GetHelpTopicMetadataResponse,
        GetHelpTopicMetadataResponse
    > | null,
) =>
    useBaseFormMetadata<
        HelpTopic,
        HelpTopicMetadataContext,
        GetHelpTopicMetadataResponse,
        GetHelpTopicMetadataRequest
    >(GetHelpTopicMetadataRequest, model, context, configuration);

export default useHelpTopicFormMetadata;
